
import $ from 'jquery';

import MiniBasket from './../libs/MiniBasket.js'
import {getSessionToken} from './Util.js';

$(document).ready(function() {

    // Update MiniBasket Data and HTML.
    MiniBasket.reload();

    // Redirect correctly when navigating to basket.
    $('a[href="/warenkorb/"]').on('click', function( evt ) {
        evt.preventDefault();
        const stoken = getSessionToken();
        window.location.href = '/index.php?cl=basket&stoken='+stoken;
    });
});

// Expose MiniBasket in global scope.
window.AclMiniBasket = MiniBasket;

// Export MiniBasket.
export default MiniBasket;
